import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ElementRef, ViewChild} from '@angular/core';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { StorageService } from 'src/app/Services/storage.service';
import { Router } from '@angular/router';

declare const Swal;


@Component({
  selector: 'g10-roster',
  templateUrl: './roster.component.html',
  styleUrls: ['./roster.component.css']
})
export class RosterComponent implements OnInit {
  public successData: any;
  public matFormSize: string = '13px';
  public setTodayDate: any = new Date();
  public cols: any = []
  public unAssignedCols: any = [
    { key: '#', display: '#' },
    {
      key: 'empRefID', display: 'Employee ID',
      config: {
        isUppercase: true,
      },
      headerConfig:{ isDefault: true}
    },
    
    {
      key: 'empName', display: 'Employee name',
      config: {
        isTruncate: true,
        truncateData: {
          limit: 20,
          concatVal: '...',
        }
      },
      headerConfig:{ isDefault: true}
    },
    { key: 'gender', display: 'Gender' },
    // { key: 'shiftTime', display: 'Shift Time' },
    // {
    //   key: 'etaStr', display: 'ETA',
    //   headerConfig: { isUppercase: true },
    // },
    {
      key: 'empAddress', display: 'Address',
      config: {
        isTruncate: true,
        truncateData: {
          limit: 20,
          concatVal: '...',
        }
      }
    },
  ]
  public assignCols: any = [
    { key: '#', display: '#' },
    {
      key: 'empRefID', display: 'Employee ID',
      config: {
        isUppercase: true,
      },
      headerConfig:{ isDefault: true}
    },
    {
      key: 'empName', display: 'Employee name',
      config: {
        isTruncate: true,
        truncateData: {
          limit: 20,
          concatVal: '...',
        }
      },
      headerConfig:{ isDefault: true}
    },
    { key: 'gender', display: 'Gender' },
    {
      key: 'driverName', display: 'Driver name', config: {
        isTruncate: true,
        truncateData: {
          limit: 20,
          concatVal: '...',
        }
      },
      headerConfig:{ isDefault: true}
    },
    {
      key: 'vehRegNo', display: 'Reg no',
      config: {
        isVehicle: true,
      },
      headerConfig:{ isDefault: true}
    },
    { key: 'shiftTime', display: 'Shift time',  headerConfig:{ isDefault: true} },
    {
      key: 'etaStr', display: 'ETA',
      headerConfig: { isUppercase: true },
 
    },
    {
      key: 'empAddress', display: 'Address',
      config: {
        isTruncate: true,
        truncateData: {
          limit: 20,
          concatVal: '...',
        }
      }
    }

  ]
  public tableData: any = []
  public noDataFoundEnable: boolean = false;
  public showTable: boolean = true;
  public isEmpTable: boolean = false;
  public listOfEmpolyers: any = '';
  public currentDate: boolean = true;
  public formSubmitted: boolean = false;
  public todayDate:any= new Date(new Date().setHours(0, 0, 0, 0)).getTime();
  // Form variables
  public uploadForm: FormGroup;
  public filterFormGrp: FormGroup;
  public formSubmit: boolean = false;
  public loginFormData: any = {};
  public filterFormData: any = {}
  public errorMsg: any = '';
  public fileValid: boolean = false;
  public listWiseDropdown: boolean = false;
  public filteredObj: any = {};
  public vehObjList: any = {};
  public empsLoader: boolean = false;
  // Error Variable
  public errMsg: any = {};
  public showErrMsg: any = '';
  // excelVariables
  public xlFileName: any = ''
  public excelData = {};
  public showDownloadBtn: boolean = false;
  public successDataLen: any = 0;
  public errDataLen: any = 0;
  public totlErrs: any = '';
  public fatErr: boolean = false;
  public loginRouteID: string = '';
  public logoutRouteID: string = '';
  public getRow: any = '';
  public getNameOfErr: any = '';
  public successEmpId: any = ''
  public checkBoxValue: Boolean = false;
  public checkBoxShow: boolean = false;
  public getUploadedType: any = 'singleDay';
  public setMinDate = new Date();
  public maxEndDate = new Date();
  public errorObject: any = {};
  public checkedDatas: any = [];
  public disableBtn: boolean = true;
  public getvehicles: any = [];
  public shiftInformation: any = [];
  public dateLoader:boolean = true;
  // Variables for branch
  public branchLists:any = [];
  public selectedBranch = [];
  @ViewChild('branchSearch') branchSearchTextBox: ElementRef;
  branchSearchChangeObserver:any;
  public enableBranchField:boolean = false;
  public branchSearchVal:any = '';
  public showFilName:Boolean=false;
  public selBranchID:any = '';
  public disableAllInputs:boolean=false;
  public localStorage;
  public resetBtnCrtl:boolean=true;
public showHintMsg:boolean=true;


  constructor(
    public swal: SweetAlert,
    private api: ApiService,
    public storage: StorageService,
    private com: CommonServices,
    private excel: ExcelExportService,
    private dateAdapter: DateAdapter<Date>,
    public router:Router
  ) {
    this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
  }

  ngOnInit(): void {
    this.filterFormsLoad();
    this.uploadFormLoad();
    this.getBranchList();
    this.getRouteIDS();
    this.listRosterAPICall();
    this.resetBtnCrtl=true;
  }

  public getBranchName:any=''
  // search bar in branch
  getBranchList(name?){
    this.enableBranchField = false;
    this.branchLists = [];
    const obj = {};
    if(name) obj['branchName'] = name;

    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status == 'success') {
        if(res.data && res.data.length > 0){
          res.data.map((item) => {
            try{
              if(item.branchName && item.branchID){
                let branchObj = {
                  name: item.branchName, 
                  value: item.branchID,
                };                
                let pushObj:boolean = true;
                this.branchLists.map((option)=>{ if(option.value==branchObj.value){ pushObj=false; }});      
                if(pushObj) this.branchLists.push(branchObj);

                if(item.isDefault){
                  this.selBranchID = item.branchID;
                  this.uploadForm.controls['branch'].patchValue(item.branchID);
                }
              }
            }catch(err){
              console.log('branch',err);
            }
          });
        }
      }
      setTimeout(()=>{ this.enableBranchField = true},200);
    }).catch((err) => {
      console.log(err);
    });
  }
  branchSearchChange(searchValue: string) {
    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.branchSearchChangeObserver) {
      new Observable(observer => {
        this.branchSearchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here
          this.getBranchList(term);
        });
    }

    this.branchSearchChangeObserver.next(searchValue);
  }
  branchSelectionResult(value){
    if(!Array.isArray(value)) value = [value];
    let result = [];
    let removedResult = [];
    for(let i=0;i<value.length;i++){
      let val = value[i];
      this.selectedBranch.map((item)=>{
        if(item.value==val){
          let valIndex = result.findIndex((e)=> e.value==item.value);
          if(valIndex==-1) result.push(item);
        }
      })
      this.branchLists.map((veh)=>{
        if(veh.value==val){
          let valIndex = result.findIndex((e)=> e.value==veh.value);
          if(valIndex==-1) result.push(veh);
        }
      })
    }
    this.selectedBranch.map((branch)=>{
      if(!value.includes(branch.value)){
        let pushObj:boolean = true;
        removedResult.map((e)=>{ if(e.value==branch.value) pushObj=false; });      
        if(pushObj) removedResult.unshift(branch);
      }
    })
    this.enableBranchField = false;
    this.branchLists = [ ...removedResult,...this.branchLists]
    this.enableBranchField = true;

    this.selectedBranch = [ ...result];
    if(this.branchSearchTextBox && this.branchSearchTextBox.nativeElement) 
      this.branchSearchTextBox.nativeElement.value = '';
    this.clearDuplicates();
  }
  clearDuplicates(){
    let result = [];
    this.enableBranchField = false;
    this.branchLists.map((branchObj)=>{

      let pushObj:boolean = true;
      this.selectedBranch.map((item)=>{ if(item.value==branchObj.value) pushObj=false; });      
      if(pushObj) result.push(branchObj);
      
    });
    this.branchLists = [ ...result];
    this.enableBranchField = true;
  }

  clearBranchSearch(event) {
    this.branchSearchTextBox.nativeElement.value = '';
    this.getBranchList();
  }

  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  // Get Datalist from API
public rosterLists:any='';
public getSkipRow:any='';
public getExcelHeaders:any=''
  listRosterAPICall(){
    let orgid = this.storage.get('userInfo');
    let obj={
        orgID: orgid['orgID'],
    }
    this.api.masterRosterListMapping(obj).then((res:any)=>{
      if(res && res['data'] && res['data'].length > 0 ){
        this.rosterLists = res['data']
          this.rosterLists.map((list:any)=>{
            if(list && list['rosters'] &&  Object.keys(list).length > 0 && list['rosters']['excelMapping'] &&
            Object.keys(list['rosters']['excelMapping']).length > 0){
              this.getSkipRow = list['rosters']['excelMapping']['skipRow']
              this.uploadForm.controls['skipRow'].patchValue(this.getSkipRow);
              this.getExcelHeaders = Object.keys(list['rosters']['excelMapping']);
          }
        })
      }
    })
  }

  updateRosterAPICall(obj){
    this.api.masterRosterUpdateMapping(obj).then((updateResponse:any)=>{
    })
  }

  // Hint Message Area
  public showResHints:boolean= true;
  public showHybridHints:boolean= false;
  public getRosterMode:any='';
  hintChange(e:any){
    if(e.value=='true'){
    this.showHybridHints=false;
    this.showResHints=true;
    }
    else if(e.value=='false'){
    this.showResHints=false;
    this.showHybridHints=true;
    }
  }
  checkBoxView(con: any) {
    if (con == 'true') {
      this.checkBoxShow = true;
    }
  }

  checkBoxObj(e: any, i: any) {
    if (e.checked == true) {
      this.tableData[i]['checked'] = true;
      this.checkedDatas.push(this.tableData[i]['checked']);
    } else if (e.checked == false) {
      this.tableData[i]['checked'] = false;
      this.checkedDatas.pop();
    }
    // Disable and enable merge btn
    if (this.checkedDatas.length >= 2) {
      this.disableBtn = false;
    } else {
      this.disableBtn = true;
    }
  }
  // Click to merge the empolyeess
  mergeRoute() {
    // public getDrivName:any=[]
    // this.getDriverName.forEach((c) => {if(!this.getDrivName.includes(c)) this.getDrivName.push(c) });
    // console.log(this.getDrivName)

    let obj = {
      routeID: this.filterFormGrp.controls['transitMode']['value'] == 'Pickup' ? this.loginRouteID : this.logoutRouteID,
      transitMode: this.filterFormGrp.value.transitMode,
      tripDate: new Date(new Date(this.filterFormGrp.value.tripDate).setHours(0, 0, 0, 0)).getTime(),
      vehRegNo: this.filterFormGrp.value.selVehicle,
      driverName: 'Surya',
      employeeID: this.tableData.map((item) => { if (item.checked) return item.employeeID }).filter((item) => item != undefined),
    }
    this.api.transportManagerRosterMerge(obj).then((res: any) => {
      if (res && res.status == 'success') {
        this.swal.swalFunction(res.status, 'success', res.message, 2000);
        this.listAPICall({
          transitMode: this.filterFormGrp.value.transitMode,
          tripDate: new Date(new Date(this.filterFormGrp.value.tripDate).setHours(0, 0, 0, 0)).getTime(),
          assigned: this.filterFormGrp.value.assigned,
          routeID: this.filterFormGrp.controls['transitMode']['value'] == 'Pickup' ? this.loginRouteID : this.logoutRouteID //Login's ID
        });
        this.checkBoxShow = false;
      } else {
        this.swal.swalFunction(res.status, 'failure', res.message, 2000);
      }
    }).catch((err) => {
      console.log(err);
    })
  }
  public datePickerMode:any='single';
  async routeDaysCtrl(e: any) {
    this.dateLoader = false;
    const selectedMode = e.value
    if(selectedMode =='range'){  
      this.datePickerMode = selectedMode; 
    }else if(selectedMode =='multiple'){
      this.datePickerMode = selectedMode; 
    }else{
      this.datePickerMode = 'single';
    }
    this.uploadForm.value.date = [this.setTodayDate];
    // (getUploadedType && getUploadedType=='range') ? 'range':( getUploadedType=='multiple' ? 'multiple' : '')
    await this.com.sleep(10);
    this.dateLoader = true;
  }

  validation(data) {
    if (this.errorObject['invalidDate']) delete this.errorObject['invalidDate'];
    let objectKeys = Object.keys(data);
    let isValid = true;
    for (let i = 0; i < objectKeys.length; i++) {
      let key = objectKeys[i];
      this.errorObject[key] = '';
      if (data[key] == '' || data[key] == undefined || data[key] == null || Number.isNaN(data[key]) || data.length <= 0) {
        this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
        isValid = false;
      }
    }
    return isValid;
  }


  async getRouteIDS() {
    await this.getRouteData().catch((err) => console.log(err));
    this.listAPICall({
      transitMode: this.filterFormGrp.value.transitMode,
      tripDate: new Date(new Date(this.filterFormGrp.value.tripDate).setHours(0, 0, 0, 0)).getTime(),
      assigned: (this.filterFormGrp.value.assigned != '' && this.filterFormGrp.value.assigned == 'true') ? true
        : (this.filterFormGrp.value.assigned != '' && this.filterFormGrp.value.assigned == 'false') ? false : '',
      routeID: this.filterFormGrp.controls['transitMode']['value'] == 'Pickup' ? this.loginRouteID : this.logoutRouteID //Login's ID
    });
  }

  getRouteData() {
    return new Promise((resolve, reject) => {
      this.api.transportMangerRouteList({}).then((res: any) => {
        if (res.status == 'success') {
          if (res.data.length > 0) {
            res.data.map((route) => {
              if (route.title == 'Login') {
                this.loginRouteID = route.routeID;
              }
              else if (route.title == 'Logout') {
                this.logoutRouteID = route.routeID;
              }
            });
            if (this.loginRouteID != '' && this.logoutRouteID != '') resolve(1);
            else reject({ 'message': 'failure' })
          }
        } else reject({ 'message': 'failure' });
      }).catch((err) => reject(err));
    })
  }

  // Download sample template
  downloadTemplate() {
    document.getElementById('excelTemplate').click();
  }

  uploadFormLoad() {
    this.uploadForm = new FormGroup({
      datePeriod: new FormControl('single'),     
      date: new FormControl([this.todayDate],[Validators.required]),
      branch: new FormControl(this.selBranchID ? this.selBranchID : '',[Validators.required]),
      files: new FormControl('', [Validators.required]),
      isRestrict:new FormControl('true', [Validators.required]),
      skipRow:new FormControl('', [Validators.required , Validators.max(100), Validators.min(0)]),
    });
    this.getDatesInput =  this.com.timestampToDate(new Date(this.todayDate),'DMY');
    this.resetBtnCrtl=true;
  }

  public checkError = (controlName: string, errorName: string) => {
    return this.uploadForm.controls[controlName].hasError(errorName);
  }

  deleteUploadFile(){
    this.uploadForm.value.files = '';
  }

  public uploadFileName:any='';
  // Check is the file is XL type
  uploadExcelFile(e: any) {
    if(e.target.value!=""){
      this.uploadFileName = e.target.files[0].name;
    }else{
      this.uploadFileName = '';
    }
    this.showFilName=true;
    if (e.target.files && e.target.files[0]) {
      let file = e.target.files[0];
      if (file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
      file.type == 'application/vnd.ms-excel' || 
      file.type == 'application/vnd.ms-excel.sheet.macroEnabled.12') {
        this.fileValid = false;
        this.errorMsg = '';
      }
      else {
        this.fileValid = true;
        this.errorMsg = 'File type is invalid';
        this.showErrMsg = false;
        this.fatErr = false;
      }
      this.xlFileName = e.target.files[0].name;
    }
  }

  loginFormSubmit() {
    this.formSubmit = true
    this.uploadForm.controls.branch.markAsTouched();
    this.uploadForm.controls.skipRow.markAsTouched();
    if (this.uploadForm.valid && !this.fileValid) {
      this.disableAllInputs=true;
      this.loginFormData['branch'] = this.uploadForm.value.branch
      this.loginFormData['date'] = this.uploadForm.value.date;
        let obj={ pickup:this.loginRouteID, drop:this.logoutRouteID }
      this.loginFormData['routeID'] = obj
      this.loginFormData['datePeriod'] = this.uploadForm.value.datePeriod;
      this.loginFormData['isRestrict']=(this.uploadForm.value.isRestrict=='true') ? true :(this.uploadForm.value.isRestrict=='false') ? false :'';
      this.loginFormData['skipRow'] = this.uploadForm.value.skipRow;
    setTimeout(()=>{
      this.uploadForm.controls['skipRow'].disable();
      this.uploadForm.controls['files'].disable();
    },800)
      this.showErrMsg = false;
      this.fatErr = false;
      let orgid = this.storage.get('userInfo');
      this.updateRosterAPICall({
        isDefault : false,
        orgID: orgid['orgID'],
        skipRow: this.uploadForm.value.skipRow
      })
      setTimeout(()=>{
        this.loginFormAPICall(this.loginFormData);
        this.listRosterAPICall();
      },2000)
      this.empsLoader = true;
    }
  }
  
  checkExcelUploadFailure(obj){
    let failureStatus = false;
    if(obj && obj['failure'] && Object.keys(obj['failure']).length>0){
      Object.keys(obj['failure']).map((date:any)=>{
        let failureData = obj['failure'][date];
        if(failureData && Object.keys(failureData).length>0){
          failureStatus = true;
        }
      })
    }
    return failureStatus;
  }

  public errShowing:any='';
  public refereceMsg:boolean=false;
  loginFormAPICall(obj: any) {
    this.successDataLen = 0;
    this.refereceMsg = false;

    let url = 'organization/route/createRost'
    this.api.xlsxFileUpload(obj, url, 'files', (apiRes: any) => {
      let res = apiRes['responseJSON'];
      this.errMsg = '';
      this.empsLoader = false;
      this.resetBtnCrtl=false;
      this.showHintMsg=false
      // Fat Error Msg // Working Fine
      if (res && res['status'] == 'failure' && res['message']!='') {
        this.fatErr = true;
        if(res['message']=='Token expired'){ this.router.navigateByUrl('organization/transport-manager/login'); }
        let errHtml = `<strong>${res['message']}</strong>`;
        if(res['message'].includes('#')){
          let [titleContent , errorSheets ] = res['message'].split('#');
          if(titleContent){
            errHtml  = `<strong>${titleContent}</strong>`;
          }
          if(errorSheets){
            errorSheets = errorSheets.split(',');
            if(errorSheets.length>0){
              errHtml += `<ol class="error-ol-overflow">` 
              errorSheets.map((sheet)=>{
                let liEl  = `<li>${sheet}</li>`;
                errHtml += liEl;
              })
              errHtml += '</ol>';
            }
          }
        }
        this.totlErrs = errHtml;
      } 
     
      // All employee added Swal // Working fine
      else if((!this.checkExcelUploadFailure(res) || res['status']=='success') && res && res['success'] && 
      res['success'].length > 0 && ( Object.keys(res['failure']['header']).length <= 0) && Object.keys(res['failure']['field']).length <= 0 ){
        let successMsg = 'Successfully updated'; //Working Awesome
        this.listAPICall({
          transitMode: this.filterFormGrp.value.transitMode,
          tripDate: new Date(new Date(this.filterFormGrp.value.tripDate).setHours(0, 0, 0, 0)).getTime(),
          assigned: (this.filterFormGrp.value.assigned != '' && this.filterFormGrp.value.assigned == 'true') ? true
            : (this.filterFormGrp.value.assigned != '' && this.filterFormGrp.value.assigned == 'false') ? false : '',
          routeID: this.filterFormGrp.controls['transitMode']['value'] == 'Pickup' ? this.loginRouteID : this.logoutRouteID //Login's ID
        });
        this.swal.swalFunction('success', 'success', successMsg, 1000);
        document.getElementById('modalCloseBtn').click();
        this.resetModalForm();
        for(let c=0;c < res['success'].length;c++){
          this.successDataLen += res['success'][c]['empInfo'].length
      }
      }
     
      // Success >0 and failure['header'] || failure['field'] 
      else if( res && res['success'] && res['success'].length > 0 && 
      (res['failure'] && res['failure']['field'] && Object.keys(res['failure']['field']).length > 0 ||
        res['failure'] && res['failure']['header'] && Object.keys(res['failure']['header']).length > 0) 
      ){
        this.refereceMsg=true
        // Header Only
        Object.keys(res['failure']['header']).map((date)=>{
          let dateWiseErr = res['failure']['header'][date];
          Object.keys(dateWiseErr).map((row:any)=>{
            Object.keys(dateWiseErr[row]).map((errMsg:any)=>{
              this.errDataLen = Object.keys(dateWiseErr[row]).length
              this.errMsg += `<br><tr><td><strong>${date}</strong> - </td><td><strong>${errMsg}</strong> - </td><td>${dateWiseErr[row][errMsg]}</td> </tr>`
            })
          })
        })
        // Fields Only
        Object.keys(res['failure']['field']).map((date)=>{
            let dateWiseErr = res['failure']['field'][date]; 
            Object.keys(dateWiseErr).map((row:any)=>{
              this.errDataLen = Object.keys(dateWiseErr[row]).length
              this.errShowing += `<br><tr><td><strong>${row}</strong> - </td><td><strong>${dateWiseErr[row]}</strong> - </td></tr>`
            })
          })


        // If Any success data
        if(res['success'] && res['success'].length > 0){
          for(let c=0;c < res['success'].length;c++){
            this.successDataLen += res['success'][c]['empInfo'].length
        }
            if (this.successDataLen > 0) {
              this.showErrMsg=true;
              this.refereceMsg=true;
              this.listAPICall({
                transitMode: this.filterFormGrp.value.transitMode,
                tripDate: new Date(new Date(this.filterFormGrp.value.tripDate).setHours(0, 0, 0, 0)).getTime(),
                assigned: this.filterFormGrp.value.assigned,
                routeID: this.filterFormGrp.controls['transitMode']['value'] == 'Pickup' ? this.loginRouteID : this.logoutRouteID //Login's ID
              });
            }
          }

        this.resultExcelDownload(res['failure'], res['success']);
      }
     
      // Header miss error // Working fine
      else if((res && res['failure'] && res['failure']['header'] && Object.keys(res['failure']['header']).length > 0)){
        Object.keys(res['failure']['header']).map((date)=>{
          let dateWiseErr = res['failure']['header'][date];
          this.refereceMsg=true;
          Object.keys(dateWiseErr).map((row:any)=>{
            Object.keys(dateWiseErr[row]).map((errMsg:any)=>{
              this.errMsg += `<br><tr><td><strong>${date}</strong> - </td><td><strong>${errMsg}</strong> - </td><td>${dateWiseErr[row][errMsg]}</td> </tr>`
            })
          })
        })
        this.resultExcelDownload(res['failure'], res['success']);
      }

      // Field Empty error msg // Working fine
      else if((res && res['failure'] && res['failure']['field'] && Object.keys(res['failure']['field']).length > 0)){
        Object.keys(res['failure']['field']).map((date)=>{
          let dateWiseErr = res['failure']['field'][date]; 
          Object.keys(dateWiseErr).map((row:any)=>{
            this.refereceMsg=true;
            this.errShowing += `<br><tr><td><strong>${row}</strong> - </td><td><strong>${dateWiseErr[row]}</strong> - </td></tr>`
          })
        })
        this.resultExcelDownload(res['failure'], res['success']);
      } 
    })
  }

  filterFormsLoad() {
    this.filterFormGrp = new FormGroup({
      assigned: new FormControl('true',),
      // search: new FormControl('',),
      tripDate: new FormControl(new Date,[Validators.required]),
      transitMode: new FormControl('Pickup'),
      empList: new FormControl(['excel']),
      selVehicle: new FormControl(''),
    })
  }
  public filterFormcheckError = (controlName: string, errorName: string) => {
    return this.filterFormGrp.controls[controlName].hasError(errorName);
  }

  getDaysArray(start, end) {
    let dateArr = [];
    for (const dt: Date = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
      dateArr.push(new Date(dt).getTime());
    }
    return dateArr;
  };
  public getDatesInput:any=''
  getSelectedDates(e: any) {
    this.getDatesInput= e.dateStr
    if(e.dateStr.includes("to")){
      const [startDate,endDate] = e.dateStr.split(' to ');
      let getLoopDate = this.getDaysArray(new Date(new Date(startDate).setHours(0,0,0,0)).getTime(),new Date(new Date(endDate).setHours(0,0,0,0)).getTime());
      this.uploadForm.controls['date'].patchValue(getLoopDate);
    }else{
      let dateValue = e.dateStr.split(',').map((date) => {
        return new Date(new Date(date.trim()).setHours(0,0,0,0)).getTime();
      })
      this.uploadForm.controls['date'].patchValue(dateValue);
    }
  }

  listAPICall(obj: any) {
    let vehArr = [];
    this.filteredObj = obj;
    this.api.transportManagerRosterList(obj).then((res: any) => {
      if (res && res.status == 'success') {
        if (res['data'] && res['data'].length > 0) {
          this.changeTableView(obj['assigned']);
          this.tableData = res.data;
          for (let i = 0; i < this.tableData.length; i++) {
            if(this.filteredObj['assigned']) this.tableData[i]['driverName'] = this.tableData[i]['driver']['name']
            this.tableData[i]['checked'] = this.checkBoxValue
            // vehArr.push(this.tableData[i]['vehRegNo']);
          }
          // vehArr.forEach((s: any) => { if (!this.getvehicles.includes(s)) this.getvehicles.push(s) });
          this.listOfEmpolyers = res['data'];
          this.showTable = true;
          this.noDataFoundEnable = true;
        }
      } else {
        this.tableData = [];
        this.noDataFoundEnable = true;
      }
    }).catch((err) => {
      console.log(err);
    })
    if (this.listOfEmpolyers.length > 0)
    {
      this.currentDate = false;
      this.showDownloadBtn=true
    }
  }

  assignedValues(e) {
    if (e == 'false') {
      this.listWiseDropdown = true;
    } else if (e == 'true') {
      this.listWiseDropdown = false;
    }
  }

  changeTableView(value: any) {
    if (value) {
      this.cols = this.assignCols;
      if(this.filteredObj.tripDate >= new Date(new Date().setHours(0,0,0,0)).getTime()){
        if((this.cols.findIndex((col)=>col.key=='action'))==-1){
          this.cols.push({
            key: 'action',
            display: 'Action',
            config: {
              isAction: true,
              actions: [
                { display: 'Remove', color: 'warn', icon: 'Delete' }
              ]
            }
          })
        }
      }
      else{
        this.cols = this.cols.filter((item)=>item.key!='action');
      }
      this.isEmpTable = true;
    } else{
      this.cols = this.unAssignedCols;
      this.isEmpTable = true;
    }
  }

  empListChange(event) {
    if (event && event.value && event.value.includes('employee')) {
      event.value = ['employee'];
      this.filterFormGrp.controls['empList'].patchValue(event.value);
    }
  }

  resetModalForm() {
    this.empsLoader = false;
    this.disableAllInputs=false;
    this.uploadForm.controls['skipRow'].enable();
    this.uploadForm.controls['files'].enable();
    this.formSubmit = false;
    this.uploadForm.reset();
    this.uploadForm.patchValue({
      datePeriod:'single',     
      date: [this.setTodayDate],
      branch: this.selBranchID ? this.selBranchID : '',
      files:'',
      isRestrict:'true',
      skipRow:this.getSkipRow,
    });
    this.routeDaysCtrl({ value: this.uploadForm.value.datePeriod });
    this.getDatesInput =  this.com.timestampToDate(new Date(this.setTodayDate),'DMY');
    this.showErrMsg=false;
    this.fatErr=false;
    this.showHybridHints=false;
    this.showResHints=true;
    this.showFilName=false;
    this.refereceMsg=false;
    this.resetBtnCrtl=true;
    this.showHintMsg=true;
    this.fileValid=false;
  }

  onSubmit() {
    this.formSubmitted = true;
    this.showDownloadBtn = false;
    let isValid = this.filterFormGrp.valid;
    if (isValid) {
      let obj = {}
      // if (this.filterFormGrp.value.search != '') obj['search'] = this.filterFormGrp.value.search;
      if (this.filterFormGrp.value.tripDate != '') obj['tripDate'] = new Date(new Date(this.filterFormGrp.value.tripDate).setHours(0, 0, 0, 0)).getTime();
      if (this.filterFormGrp.value.transitMode != '') obj['transitMode'] = this.filterFormGrp.value.transitMode;
      
      if (this.filterFormGrp.value.assigned != '') {
        obj['assigned'] = (this.filterFormGrp.value.assigned != '' && this.filterFormGrp.value.assigned == 'true') ? true
          : (this.filterFormGrp.value.assigned != '' && this.filterFormGrp.value.assigned == 'false') ? false : '';
      }
      if (this.filterFormGrp.value.assigned == 'false') {
        if (this.filterFormGrp.value.empList != '') {
          let empListArr = [];
          empListArr.push(this.filterFormGrp.value.empList)
          obj['empList'] = this.filterFormGrp.value.empList;
        }
      }
      obj['routeID'] = obj['transitMode']=='Pickup'?this.loginRouteID:this.logoutRouteID,
      this.listAPICall(obj)
      this.showDownloadBtn = true;
    }
  }

  async exportToExcel() {
    this.excelData={};
    let data = [];
    for (let i = 0; i < this.listOfEmpolyers.length; i++) {
      let item = this.listOfEmpolyers[i];
      try {
        let res = {
          value:  (this.filteredObj['assigned'] == true) ? [
            i + 1,
            item.empRefID ? String(item.empRefID).toUpperCase() : '---',
            item.empName ? this.com.convertTitleCase(item.empName) : '---',
            item.gender ? this.com.convertTitleCase (item.gender) : '---',
            item.shiftTime ? item.shiftTime : '---',
            (item.vehRegNo  && this.filteredObj['assigned']==true) ? String(item.vehRegNo).toUpperCase():'---',
            item.driverName? this.com.convertTitleCase (item.driverName) :'---',
            item.etaStr ? item.etaStr : '---',
            item.empAddress ? this.com.convertTitleCase (item.empAddress) : '---',
          ] :
          [ 
            i + 1,
            item.empRefID ? String(item.empRefID).toUpperCase() : '---',
            item.empName ? this.com.convertTitleCase(item.empName) : '---',
            item.gender ? this.com.convertTitleCase (item.gender) : '---',
            item.empAddress ? this.com.convertTitleCase (item.empAddress) : '---',
          ],
        }
        data.push(res);
      } catch (err) {
        console.log(err);
      }
    }
    if (data.length > 0) {
      let rowCount = 2;
      let endCell = this.filteredObj['assigned'] ? 'I' : 'E';
      let customizedData = [];
      let titleRow = {
        value: [this.filteredObj['assigned'] ? 'Assigned List' : 'Unassigned List'],
        font: {
          name: 'Corbel', family: 4, size: 16, bold: true,
          color: { argb: 'FFFFFFFF' },
        },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
        alignment: {
          cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '966462AF' },
          bgColor: { argb: 'FFF' }
        },
      }
      customizedData.push(titleRow);

      rowCount = this.filteredObj['assigned'] == false ? rowCount + 3 : rowCount + 2;

      let subtitleRow = {
        value: this.filteredObj['assigned'] == false ? [
          "Title :" + this.filterFormGrp.value.empList.map((item) => this.com.convertTitleCase(item)).join(',') + ' List' + "\n" +
          "Trip Date          : " + this.com.timestampToDate(new Date(this.filteredObj['tripDate']).getTime(), 'DMY') + "\n" +
          "Transit Mode    : " + this.filteredObj['transitMode'] + ""
        ] :
          [
            "Trip Date          : " + this.com.timestampToDate(new Date(this.filteredObj['tripDate']).getTime(), 'DMY') + "\n" +
            "Transit Mode    : " + this.filteredObj['transitMode'] + ""
          ],
        font: { name: 'Corbel', family: 4, size: 12, },
        mergeCells: this.filteredObj['assigned'] == false ? `A${(rowCount - 2) + ''}:${endCell + rowCount + ''}` : `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      }

      customizedData.push(subtitleRow);

      rowCount = rowCount + 1;
      let headerRow =
      {
        value: this.filteredObj['assigned'] ? ['S No', 'Employee ID', 'Employee name', 'Gender', 'Shift time', 'Reg no', 'Driver name', 'ETA', 'Address'] :
          ['S No', 'Employee ID', 'Employee name', 'Gender', 'Address'],
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFFFF00' },
          bgColor: { argb: 'FF0000FF' }
        },
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
      }
      customizedData.push(headerRow);

      customizedData.push(...data);
      let excelSheetName = this.filteredObj['assigned'] ? 'Assigned List' : 'Unassigned List'

      if (this.excelData[excelSheetName] == undefined) { this.excelData[excelSheetName] = {}; }

      this.excelData[excelSheetName] = {
        customizedData: customizedData,
        data: {
          columWith: this.filteredObj['assigned'] ? [{ colNo: 2, width: 25 }, { colNo: 3, width: 25 }, { colNo: 4, width: 15 }, { colNo: 5, width: 15 }, { colNo: 6, width: 20 }, { colNo: 7, width: 25 }, { colNo: 8, width: 15 }, { colNo: 9, width: 50 }] :
            [{ colNo: 2, width: 25 }, { colNo: 3, width: 25 }, { colNo: 4, width: 15 }, { colNo: 5, width: 30 }, { colNo: 6, width: 20 }, { colNo: 7, width: 35 }, { colNo: 8, width: 15 }, { colNo: 9, width: 50 }],
        }
      };// excelInfo;

      this.downloadExlReport();

    }

  }

  downloadExlReport() {
    this.excel.generateExcel(this.excelData, this.filteredObj['assigned'] ? 'Assigned List' + new Date().getTime() : 'Unassigned List' + new Date().getTime() + '.xlsx');
  }

  onActionHandler(e: any) {
    if (e && e.action.display == 'Remove') {
      let obj = {
        rosterID:e.data.rosterID,
        empRefID:e.data.empRefID,
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to remove this employee!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',//'#3085d6',
        //  cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, remove it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.unassignEmp(obj);
        }
      });
    }
  }

  unassignEmp(removeObj) {
    this.api.transportManagerRosterUpdate(removeObj).then((res: any) => {
      if (res.status == 'success') {
        this.listAPICall(this.filteredObj);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  public getTransMode:any=''
  async resultExcelDownload(obj: any, successObj: any) {

    let rowCount = 2;
    let customizedData = [];
    let endCell = 'F';

    let titleRow = {
      value: ['Roster Upload Report'],
      font: {
        name: 'Corbel', family: 4, size: 16, bold: true,
        color: { argb: 'FFFFFFFF' },
      },
      mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      alignment: {
        cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
      },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '966462AF' },
        bgColor: { argb: 'FFF' }
      },
    }
    customizedData.push(titleRow);
    // "Mode of Roster     : " + (this.getRosterMode=='true') ? 'Restrict' :(this.getRosterMode=='false') ? 'Hybrid' :'' 
    rowCount += 2;//4
    let subtitleRow = {
      value: [
        "Trip Date          : " + this.getDatesInput + "\n"
      ],
      font: { name: 'Corbel', family: 4, size: 12, },
      mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
    }
    customizedData.push(subtitleRow);

    let resExcelData = {};
    let res = {}
    let data = [];

    let successData = [];
    let errorData = [];
    if(successObj && successObj.length>0){
      rowCount += 2;//6
      let successCountRow = {
      value:[
        "Success Counts          : " + this.successDataLen + "\n"
      ],
      font: { name: 'Corbel', family: 4, size: 12, },
      mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      }
      customizedData.push(successCountRow);
      
      rowCount+= 1;
      let successHeadersRow =
      {
        value: ['S No','Trip date','Transit mode','Employee ID','Shift time','Vehicle'],
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      }
      // Success MSG
      let serialNo = 1;
      for(let i=0; i< successObj.length;i++){
        try {
          let vehRegNo = successObj[i]['vehRegNo']
          let shiftTime = successObj[i]['shiftTimeStr']
          successObj[i]['empInfo'].map((empRefID:any)=>{
          this.successEmpId = empRefID['empRefID']
          this.getTransMode= successObj[i]['transitMode']
              res = {
              value: [
                serialNo,
                this.com.timestampToDate(successObj[i]['tripDate'],'DMY','-'),
                this.getTransMode,
                this.successEmpId,
                shiftTime,
                vehRegNo
              ],
            }
            rowCount+=1;
            serialNo+=1;
            successData.push(res);
          })
        } catch (err) { console.log(err) }
      
      }
      customizedData.push(successHeadersRow, ...successData);
    }

    if (obj && Object.keys(obj).length>0) {

    rowCount += 1;//6
    let emptyCountRow = {
     value:[''],
     font: { name: 'Corbel', family: 4, size: 12, },
     mergeCells: `A${(rowCount) + ''}:${endCell + rowCount + ''}`,
    }
    customizedData.push(emptyCountRow);

      rowCount += 2;
      let errCountRow = {
        value: [
          "Error Counts          : " + this.errDataLen + "\n"
        ],
        font: { name: 'Corbel', family: 4, size: 12, },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      }
      rowCount = rowCount + 1;
      let errHeaderRow =
      {
        value: ['S No','Trip Date','Row No','Error'],
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
        mergeCells: `D${rowCount}:F${rowCount}`,
      }

      let errCount = 0;
      if(obj && Object.keys(obj).length>0){
        Object.keys(obj).map((headKey)=>{
          // Header Error Message
          if( headKey && headKey == 'header'  && Object.keys(headKey).length>0){
           Object.keys(obj['header']).map((date)=>{
             let dateWiseErr = obj['header'][date]; 
             this.errDataLen= obj['header'][date].length; 
             Object.keys(dateWiseErr).map((row:any)=>{
              Object.keys(dateWiseErr[row]).map((errorRow:any)=>{
                let errMsg = dateWiseErr[row][errorRow].toString()
                errCount+=1;
                try {
                  rowCount = rowCount + 1;
                  res = {
                  value:[
                    errCount,
                    date,
                    errorRow,
                    errMsg
                  ],
                }
                errorData.push(res);
                } catch (err) { console.log(err) }
              })
             })
           })
          }
        })
        Object.keys(obj).map((fieldKey)=>{
          // Field Error Msg
          if(fieldKey && fieldKey=='field'&& Object.keys(fieldKey).length>0){
            Object.keys(obj['field']).map((date)=>{
              let dateWiseErr = obj['field'][date]; 
              this.errDataLen=  Object.keys(obj['field'][date]).length; 
              Object.keys(dateWiseErr).map((row:any)=>{
                this.getRow = row
                this.getNameOfErr= dateWiseErr[row].toString()
                errCount+=1;
                try {
                  rowCount = rowCount + 1;
                  res = {
                  value:[
                    errCount,
                    date,
                    this.getRow,
                    this.getNameOfErr
                  ],
                  mergeCells: `D${rowCount}:F${rowCount}`,
                }
                errorData.push(res);
                } catch (err) { console.log(err) }
              })
            })
          }
        })
      }

      errCountRow['value'] = ["Error Counts          : " + this.errDataLen + "\n"];

      customizedData.push(errCountRow,errHeaderRow, ...errorData);


      let excelSheetName = 'Roster-Upload-Report';

      if (resExcelData[excelSheetName] == undefined) { resExcelData[excelSheetName] = {}; }


      resExcelData[excelSheetName] = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 1, width: 15 }, { colNo: 2, width: 15 }, { colNo: 3, width: 15 }, { colNo: 4, width: 30 },{ colNo: 5, width: 30 },{ colNo: 6, width: 30 }]
        }
      };
      
    }
    if((successObj && successObj.length>0) || (obj && Object.keys(obj).length>0)){
      this.excel.generateExcel(resExcelData, 'Roster-Upload-Report.xlsx');
    }
  }


  rosterExcelTemplate(){
    let dates = [];
    let tempExlData = {};
    if(this.uploadForm.value.date && this.uploadForm.value.date.length>0) dates = this.uploadForm.value.date;
    else dates = [ new Date().getTime() ]; 

    for(let d=0;d<dates.length;d++){

      let customizedData = [];
      let loopDate = new Date(dates[d]);
      let headerRow =
      // value : this.getExcelHeaders,
      {
          value: ['S No', 'Employee ID','Employee name','Employee mobile','Gender','Shift time','Pickup ETA','Pickup address','Pickup vehicle driver','Drop ETA','Drop address','Drop vehicle driver','Area','Branch','Start time(P)','End time(P)','Start location(P)','End location(P)','Start time(D)','End time(D)','Start location(D)','End location(D)','Trip sheet ID','Project','User type','Vendor name'],  
          font: { bold: true },
          border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
        }
        customizedData.push(headerRow);

        let valueRow = {
          value: [1,'XYZ123','XXXX Y','XXXXXXXXXX','M/F/T','HH:MM:SS to HH:MM:SS','HH:MM:SS','XYZ ZZZ','XX00YY0000 XYZ XXXXXXXXXX','HH:MM:SS','XYZ ZZZ','XX00YY0000 XYZ XXXXXXXXXX','ABCXYZ','XYZ','HH:MM:SS','HH:MM:SS','11.1112,22.2222','11.1112,22.2222','HH:MM:SS','HH:MM:SS','11.1112,22.2222','11.1112,22.2222','XXX111','Development','Escort','XXX']
        }
        customizedData.push(valueRow);
  
        let excelSheetName = this.com.pad(loopDate.getDate())+'-'+this.com.pad(loopDate.getMonth()+1)+'-'+this.com.pad(loopDate.getFullYear());
        
        if(dates.length==1) excelSheetName = 'Roster'; 
        if (tempExlData[excelSheetName] == undefined) { tempExlData[excelSheetName] = {}; }

        tempExlData[excelSheetName] = {
          customizedData: customizedData,
          data: {
            columWith: [{ colNo: 2, width: 20 }, { colNo: 3, width: 25 }, { colNo: 4, width: 25 }, { colNo: 5, width: 10 }, { colNo: 6, width: 25 }, { colNo: 7, width: 25 }, { colNo: 8, width: 20 }, { colNo: 9, width: 20 },{ colNo: 10, width: 20 },{ colNo:11, width: 25 },{ colNo: 12, width: 30 },{ colNo: 13, width: 25 },{ colNo: 14, width: 25 },{ colNo: 15, width: 20 },{ colNo: 16, width: 20 },{ colNo: 17, width: 25 },{ colNo: 18, width: 25 },{ colNo: 19, width: 25 },{ colNo: 20, width: 25 },{ colNo: 21, width: 25 },{ colNo: 22, width: 25 },{ colNo: 23, width: 25 },{ colNo: 24, width: 30 },{ colNo: 25, width: 20 },{ colNo: 26, width: 25 }]
          }
        };
    }

      this.excel.generateExcel(tempExlData,'Roster-Template-' + this.com.convertTitleCase(this.datePickerMode) + new Date().getTime() + '.xlsx');
    
  }

}
